<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'

import { onEnter, prefersReducedMotion } from '@/utils/onEnter'

interface Props {
  /** Значение вида "8+", "9", "10" — анимируется числовая часть, суффикс остаётся. */
  value: string
}

const { value } = defineProps<Props>()

const el = ref<HTMLSpanElement | null>(null)
let stop: (() => void) | null = null

onMounted(() => {
  const match = /^(\d+)(.*)$/.exec(value)
  if (match === null || el.value === null) {
    if (el.value !== null) el.value.textContent = value
    return
  }

  const target = Number.parseInt(match[1] ?? '0', 10)
  const suffix = match[2] ?? ''
  const node = el.value

  stop = onEnter(node, () => {
    if (prefersReducedMotion()) {
      node.textContent = `${target}${suffix}`
      return
    }
    const duration = 1100
    const start = performance.now()
    const tick = (now: number): void => {
      const progress = Math.min(1, (now - start) / duration)
      const eased = 1 - Math.pow(1 - progress, 3)
      node.textContent = `${Math.round(target * eased)}${suffix}`
      if (progress < 1) requestAnimationFrame(tick)
    }
    requestAnimationFrame(tick)
  })
})

onUnmounted(() => stop?.())
</script>

<template>
  <span ref="el">0</span>
</template>
